
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-data-grid/demos/real-time-data",
      function () {
        return require("private-next-pages/x/react-data-grid/demos/real-time-data.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-data-grid/demos/real-time-data"])
      });
    }
  